import React, { useEffect, useState } from "react";
import "./timesheet.scss";
import { ProgressBar } from "react-bootstrap";
import TimeSheetCard from "./TimeSheetCard";
import TimeSheetGap from "./TimeSheetGap";
import { Progress } from "reactstrap";

type AppProps = {
  timeSheetListing: any;
  handleDeleteTimeSheet: (value: string) => void;
  handleEdit: (data: any) => void;
  handleCopy: (e: any, data: any) => void;
  totalTime: number;
  finalClientList: any;
  finalJobList: any;
  allActivityCode: any;
  timeSheetEntryType: string;
  handleCopyTimeSheetModal: () => void;
  sharedJob?: boolean;
  editTimeSheet?: boolean;
  deleteTimeSheet?: boolean;
  editDateTimesheet?:boolean;
};

const TimeSheetList = ({
  timeSheetListing,
  handleDeleteTimeSheet,
  handleEdit,
  handleCopy,
  totalTime,
  finalClientList,
  finalJobList,
  allActivityCode,
  timeSheetEntryType,
  handleCopyTimeSheetModal,
  sharedJob,
  editTimeSheet,
  deleteTimeSheet,
  editDateTimesheet
}: AppProps) => {
  const rendertimeSheetData = () => {
    let finalData = timeSheetListing?.data?.map((data: any) =>
      data?.type === null ? (
        <TimeSheetGap data={data} />
      ) : (
        <TimeSheetCard
          data={data}
          handleDeleteTimeSheet={handleDeleteTimeSheet}
          handleEdit={handleEdit}
          handleCopy={handleCopy}
          handleCopyTimeSheetModal={handleCopyTimeSheetModal}
          finalClientList={finalClientList}
          finalJobList={finalJobList}
          allActivityCode={allActivityCode}
          sharedJob={sharedJob}
          editTimeSheet={editTimeSheet}
          deleteTimeSheet={deleteTimeSheet}
          editDateTimesheet={editDateTimesheet}
        />
      )
    );

    return finalData;
  };
  return (
    <>
      <div className="list-header">
        <p className="timesheet-sub-heading">Summary</p>
        <p className="remaining-time">Remaining</p>
      </div>

      <div>
        <Progress
          style={{ height: "6px", backgroundColor: "#cce4e7" }}
          value={(totalTime / 8) * 100}
        ></Progress>
      </div>

      <div className="list-header mt-1">
        <div className="time-allocated">Time Allocated</div>

        <div className="billable-nobillable-hour">
          {/* <div className="sub-txt">{timeSheetEntryType==="billable" ? "Billable" : "Non-Billable"}</div> */}
          <div className="sub-txt">Total Hours : {totalTime}</div>
        </div>
      </div>

      {rendertimeSheetData()}
    </>
  );
};

export default TimeSheetList;
